const s = {
  name: "FastCheckout",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M26.6,15h2l-0.9-5h5l4.9,28H0v2h40L34.4,8h-7l-0.2-1.2c-0.7-3.8-4.3-6.8-8-6.8c-1.9,0-3.5,0.7-4.7,2.1
			c-1.2,1.4-1.6,3.2-1.3,5.1L13.3,8H9v2h4.7l0.9,5h2l-0.9-5h10L26.6,15z M25.3,8h-10l-0.2-1.2c-0.2-1.3,0.1-2.6,0.8-3.5
			C16.7,2.5,17.8,2,19.1,2c2.8,0,5.6,2.3,6.1,5.2L25.3,8z"/>
		<path class="st0" d="M13.6,18H6v2h7.6V18z"/>
		<path class="st0" d="M13.6,28H3v2h10.6V28z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as FastCheckout
};
